export default function _startTheme(){

    // Utility function to get cookie
    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    };

    // Utility function to set cookie
    const setCookie = (name, value, days) => {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    };

    // Function to update theme
    function updateTheme(theme) {
        const themeIconUse = document.querySelector('.theme-icon-use');
        const themeName = document.querySelector('.theme-name');

        if (themeIconUse) {
            const htmlElement = document.documentElement;
            if (theme === 'light') {
                themeIconUse.setAttribute('href','#light-mode-icon')
                htmlElement.setAttribute('data-color-theme', 'dark')
            } else {
                themeIconUse.setAttribute('href','#dark-mode-icon')
                htmlElement.setAttribute('data-color-theme', 'light')
            }
        }

        if (themeName) {
            if (theme === 'light') {
                themeName.textContent = 'Light colour';
            } else {
                themeName.textContent = 'Dark colour';
            }
        }
    }

    // Function to toggle theme
    function toggleTheme() {
        const themeIconUse = document.querySelector('.theme-icon-use');
        const themeName = document.querySelector('.theme-name');

        if (!themeIconUse || !themeName) {
            console.error('Theme icon or name element not found.');
            return;
        }

        // Retrieve the text content from the themeName element
        const themeText = themeName.textContent;

        // Determine the current theme based on the text content
        let currentTheme;

        if (themeText === 'Dark colour') {
            currentTheme = 'light';
        } else {
            currentTheme = 'dark';
        }

        updateTheme(currentTheme);

        // Save the selected theme in a cookie
        setCookie('theme', currentTheme, 365);
    }

    // Function to initialize theme
    function initializeTheme() {
        const button = document.querySelector('.theme-toggle-button');
        if (!button) {
            console.error('Theme toggle button not found.');
            return;
        }

        // Set the initial theme based on the cookie
        const theme = getCookie('theme') || 'light';
        updateTheme(theme);

        button.addEventListener('click', toggleTheme);

    }

    document.addEventListener("DOMContentLoaded", initializeTheme())

}